module.exports = __webpack_public_path__ + "img/play.ed6b2014.svg";